import { Environment } from '@context/shared/types/common';

export const environment: Environment = {
	app: 'web',
	production: false,
	appUrl: 'https://dev.app-context.com',
	externalAppUrl: 'https://external.dev.app-context.com',
	apiUrl: 'https://us-central1-dev-papyrus.cloudfunctions.net/api',
	supportEmail: 'support@app-context.freshdesk.com',
	algolia: {
		apiKey: 'f69e09ba63b92e8febd2a88f5208f794',
		applicationId: 'TH9RDIDBZY',
	},
	firebase: {
		apiKey: 'AIzaSyCVjinrxOw32GUmxOysT5PlPH3BWWABp3U',
		authDomain: 'dev-papyrus.firebaseapp.com',
		projectId: 'dev-papyrus',
		storageBucket: 'dev-papyrus.appspot.com',
		messagingSenderId: '621818219700',
		appId: '1:621818219700:web:1f37767078aa2145791be1',
		measurementId: 'G-RP6BP6WFZN',
	},
};
